function waitForShopifyFormEmbed(callback, interval = 300, maxAttempts = 20) {
  let attempts = 0;
  const timer = setInterval(() => {
    const el = document.querySelector("shopify-forms-embed");
    if (el && el.shadowRoot) {
      clearInterval(timer);
      callback(el);
    } else if (++attempts > maxAttempts) {
      clearInterval(timer);
      console.warn("Shopify form embed not found in time");
    }
  }, interval);
}

waitForShopifyFormEmbed((el) => {
  const shadow = el.shadowRoot;
  const style = document.createElement("style");
  style.textContent = `
    ._textHeading_2aowh_35 {
      font-size: 40px !important;
      line-height: initial !important;
    }

    ._formFieldset_cit2d_82 ._formFieldContainer_1mxsl_5 {
      flex-direction: column-reverse !important;
    }

    ._formFieldset_cit2d_82 input {
      font-size: 18px !important;
      padding: 12px !important;
    }

    ._selectToggle_12thd_25 {
      padding: 12px !important;
      min-height: 45px !important;
    }

    ._selectToggleText_12thd_25,._formSubmitButton_cit2d_96 {
      font-size: 18px !important;
    }

    ._formFieldContainer_1mxsl_5 ._inputFilled_1mxsl_74,
    ._formFieldContainer_1mxsl_5:focus-within ._formInputFieldLabel_1mxsl_38 {
      transform: none !important;
    }

    ._formFieldset_cit2d_82 label {
      position: initial !important;
      margin-bottom: 4px !important;
      color: #202020 !important;
      line-height: 20px !important;
      width: fit-content !important;
    }

    div._birthdayText_rzr7e_15 {
      padding-bottom: 0 !important;
    }

    .phone-country-selector {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
    }

    ._selectContainer_12thd_6 {
      width: 100%
    }

    div._formDisclaimer_cit2d_38 {
      font-size: 14px !important;
      line-height: initial !important;
    }

    ._formBannerHeading_z5ku3_9 {
      font-size: 40px !important;
      line-height: initial !important;
      margin-bottom: 30px !important;
    }

    #label-custom\\#model_number {
      pointer-events: auto !important;
    }
   
    @media (min-width: 768px) {
      ._textHeading_2aowh_35 {
        font-size: 48px !important;
        margin-bottom: 14px !important;
      }

      ._gridItemContent_1q1d2_257 {
        padding-top: 56px !important;
        padding-bottom: 56px !important;
      }
    }

    @media (min-width: 1024px) {
      ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
        max-width: 600px !important;
      }
    }
  `;
  shadow.appendChild(style);

  const label = shadow.querySelector('label[id="label-custom#model_number"]');
  if (label) {
    // 加入連結（例如到產品說明頁）
    const externalBtn = document.createElement("a");
    externalBtn.id = "openPopupButton";
    externalBtn.className = "find-model-number";
    // 注意：這裡使用 style.cssText 會覆蓋所有現有樣式，確保所有需要的樣式都在這裡
    externalBtn.style.cssText = `
      position: absolute !important;
      pointer-events: auto !important;
      color: #007aff !important;
      font-size: 12px;
      cursor: pointer;
      text-decoration: underline;
      background: none;
      border: none;
      padding: 0;
      margin: 0;
      z-index: 9;
    `;
    externalBtn.textContent = "How to find your model number?";
    externalBtn.href = "#"; // 確保是有效的連結，但會被 preventDefault 阻止

    // 插在 shadowHost (shopify-forms-embed) 的外面，與它同層
    el.insertAdjacentElement("afterend", externalBtn);

    // 定位函數：計算 shadow 內 label 的螢幕座標
    function repositionButton() {
      // 確保 label 仍然存在且可見
      if (!label || label.offsetParent === null) {
        // offsetParent === null 表示元素不可見或未渲染
        console.warn("Label element for positioning not found or not visible.");
        return;
      }
      const labelRect = label.getBoundingClientRect();
      const containerRect = externalBtn.offsetParent.getBoundingClientRect();
      externalBtn.style.top = `${labelRect.top - containerRect.top}px`;
      externalBtn.style.left = `${labelRect.right - containerRect.left + 8}px`;
    }

    // 初始定位
    repositionButton();

    // 監聽 resize 與 scroll 以更新位置，保證不會位移
    window.addEventListener("resize", repositionButton);
    window.addEventListener("scroll", repositionButton);
  }
});
